const MAX_SLUG_LENGTH = 40;

/** Filename-safe fragment of a name, e.g. "Genesis Dental" -> "genesis-dental". */
export function slugify(value: string): string {
    return value
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '')
        .slice(0, MAX_SLUG_LENGTH);
}
